import * as Yup from 'yup';
import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

const isValidEmail = (value?: string) => {
  if (!value) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
};

export const messageSchema = Yup.object().shape({
  message: Yup.string()
    .required('Please type your message.')
    .min(5, 'Your message should be over four (4) characters.'),
});

const ALLOWED_REGIONS = new Set(['US', 'CA', 'PR']);

export function isValidPhone(value?: string): boolean {
  if (!value) return false;
  try {
    const number = phoneUtil.parse(value, 'US');
    const region = phoneUtil.getRegionCodeForNumber(number);
    return (
      phoneUtil.isValidNumber(number) && !!region && ALLOWED_REGIONS.has(region)
    );
  } catch {
    return false;
  }
}

export const credentialsSchema = Yup.object().shape({
  firstName: Yup.string()
    .required('You must enter your first name.')
    .trim('You must enter your first name.'),
  phone: Yup.string()
    .required('You must enter a phone number.')
    .test('is-valid-phone', 'Enter a valid phone number.', (value) =>
      isValidPhone(value)
    ),
  email: Yup.string()
    .email('You must enter a valid email.')
    .required('You must enter an email.')
    .test('is-email', 'You must enter a valid email.', (value) =>
      value ? isValidEmail(value) : true
    ),
});

export const fullFormSchema = messageSchema.concat(credentialsSchema);

export const otpSchema = Yup.object().shape({
  otp: Yup.array()
    .of(Yup.string().matches(/^\d$/, 'Enter a digit.'))
    .length(6, 'Enter all 6 digits.')
    .test('all-filled', 'Enter all 6 digits.', (value) =>
      value ? value.every((v) => v && /^\d$/.test(v)) : false
    ),
});
